export const PlayerTypes = {
  TAKER: 'player_taker',
  BOT: 'player_bot'
};
